// #468 catalog bar unification: a tiny shared store for the "last add" so ONE
// CartBuilderBar (mounted once per catalog surface) can render the add feedback
// for BOTH the Magazine grid (ProductCard popovers) AND the Power Buyer rows -
// replacing the per-card QuickAddToast stack. The producer (any card / row)
// calls pushAdd(); the single consumer (CartBuilderBar) reads lastAdd. Not
// persisted: it is transient UI feedback, reset on reload. The cart itself lives
// in stores/cart.ts - this only carries the flash + which box just received the
// add so the bar can surface that box.
import { create } from "zustand";

export type LastAdd = {
  message: string;
  slug?: string;
  variant: "success" | "warning";
  at: number;
};

type CatalogFeedbackStore = {
  lastAdd: LastAdd | null;
  pushAdd: (
    message: string,
    slug?: string,
    variant?: "success" | "warning",
  ) => void;
};

export const useCatalogFeedback = create<CatalogFeedbackStore>((set) => ({
  lastAdd: null,
  pushAdd: (message, slug, variant = "success") =>
    set({ lastAdd: { message, slug, variant, at: Date.now() } }),
}));
